// La mise en forme d'un prénom ou d'un nom à l'AFFICHAGE.
//
// Le back la fait déjà à l'enregistrement (PersonNameFormatter, believemy_v3),
// mais les comptes créés avant ne sont pas rattrapés : « test », « JEAN » ou
// « marie-claire » s'affichent encore tels quels. Même règle ici, partie par
// partie (espace ou trait d'union) : une partie tout en minuscules ou tout en
// majuscules devient « Majuscule + minuscules », avec une majuscule aussi après
// une apostrophe ; une partie à casse mélangée (« McDonald ») est respectée ;
// une ou deux lettres en majuscules (« JB ») restent telles quelles.

const lower = (text) => text.toLocaleLowerCase("fr");
const upper = (text) => text.toLocaleUpperCase("fr");
const capitalize = (text) => (text ? upper(text[0]) + lower(text.slice(1)) : text);

const isShouted = (text) => text.length > 2 && text === upper(text) && text !== lower(text);

function formatPart(part) {
    if (!part) return part;
    const letters = part.replace(/[^\p{L}]/gu, "");
    if (!letters) return part;
    const pieces = part.split(/(['’])/);
    if (letters === lower(letters) || letters === upper(letters)) {
        return pieces.map((piece) => (/['’]/.test(piece) ? piece : capitalize(piece))).join("");
    }
    // Casse mélangée (« McDonald », « M'hamed ») : on la respecte, sauf un
    // morceau crié autour d'une apostrophe (« d'ARTAGNAN » → « D'Artagnan »).
    const fixed = pieces.map((piece) => (isShouted(piece) ? capitalize(piece) : piece)).join("");
    return upper(fixed[0]) + fixed.slice(1);
}

/** « marie-claire » → « Marie-Claire », « LE GALL » → « Le Gall », « McDonald » inchangé. */
export function formatPersonName(name) {
    if (typeof name !== "string") return name;
    const clean = name.trim();
    // Une ou deux lettres en majuscules (« JB ») : des initiales, on n'y touche pas.
    if (clean.length <= 2 && clean === upper(clean)) return clean;
    return clean
        .split(/([\s-]+)/)
        .map((part) => (/^[\s-]+$/.test(part) ? part : formatPart(part)))
        .join("");
}
